import { Typography } from '@atlas-metrics/design-system';
import React from 'react';

import clsxm from '@/lib/clsxm';

import { hexToRGBA } from '@/utils/hexToRGBA';

export type SubNavigationItemProps = {
  /** Unique Id of item. */
  id: string;

  /** Active selected state fo item. */
  selected?: boolean;

  /** Label of item. */
  label: string;

  /** On Click handler. */
  onClickHandler: (id: string) => void;

  /** Override or extend the styles applied to the component. */
  className?: string;

  /** Font color of the item */
  fontColor: string;
};

export const SubNavigationItem: React.FC<SubNavigationItemProps> = ({
  id,
  selected,
  label,
  onClickHandler,
  className,
  fontColor,
}) => (
  <div
    style={
      selected
        ? { color: fontColor, backgroundColor: hexToRGBA(fontColor, 0.1) }
        : {}
    }
    className={clsxm(
      'flex w-full cursor-pointer items-center gap-2 rounded-lg p-2 text-ds-grey-700 hover:bg-ds-grey-50',
      className
    )}
    data-testid='sub-nav-item'
    onClick={() => onClickHandler(id)}
    onKeyDown={(evt) => evt.key === 'Enter' && onClickHandler(id)}
    role='menuitem'
    tabIndex={0}
  >
    <Typography variant='body-s' bold>
      {label}
    </Typography>
  </div>
);
